/* ==========================================================================
   Nuvora — theme behaviour
   Countdown, drawers, AJAX cart, carousels, accordions, variant selection.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* --- Countdown -------------------------------------------------------- */

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var minutes = parseInt(el.dataset.minutes, 10) || 30;
      var key = 'solvona:countdown';
      var end = parseInt(sessionStorage.getItem(key), 10);

      if (!end || isNaN(end) || end < Date.now()) {
        end = Date.now() + minutes * 60 * 1000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }

      var h = el.querySelector('[data-countdown-hours]');
      var m = el.querySelector('[data-countdown-minutes]');
      var s = el.querySelector('[data-countdown-seconds]');
      var pad = function (n) { return String(n).padStart(2, '0'); };

      var tick = function () {
        var left = Math.max(0, end - Date.now());
        var total = Math.floor(left / 1000);
        if (h) h.textContent = pad(Math.floor(total / 3600));
        if (m) m.textContent = pad(Math.floor((total % 3600) / 60));
        if (s) s.textContent = pad(total % 60);
        if (left <= 0) {
          end = Date.now() + minutes * 60 * 1000;
          try { sessionStorage.setItem(key, String(end)); } catch (e) {}
        }
      };

      tick();
      setInterval(tick, 1000);
    });
  }

  /* --- Drawers ---------------------------------------------------------- */

  // The cart drawer leaves the page visible from tablet up, so the page should
  // stay scrollable behind it. Phones still lock, since the panel covers most
  // of the screen there and background scrolling reads as a bug.
  function setScrollLock(el, isOpen) {
    var leavesPageVisible =
      el.hasAttribute('data-cart-drawer') && window.matchMedia('(min-width: 750px)').matches;
    document.body.style.overflow = isOpen && !leavesPageVisible ? 'hidden' : '';
  }

  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    setScrollLock(el, true);
  }

  function closeDrawer(el) {
    if (!el) return;
    el.hidden = true;
    setScrollLock(el, false);
  }

  function initDrawers() {
    var cart = document.querySelector('[data-cart-drawer]');
    var menu = document.querySelector('[data-menu-drawer]');

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-open]')) {
        e.preventDefault();
        openDrawer(cart);
      }
      if (e.target.closest('[data-cart-drawer-close]')) closeDrawer(cart);
      if (e.target.closest('[data-menu-drawer-open]')) {
        e.preventDefault();
        openDrawer(menu);
      }
      if (e.target.closest('[data-menu-drawer-close]')) closeDrawer(menu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer(cart);
        closeDrawer(menu);
      }
    });
  }

  /* --- AJAX cart -------------------------------------------------------- */

  function refreshCart(open) {
    return fetch(window.routes.cart_url + '?section_id=cart-drawer-content', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var current = document.querySelector('[data-cart-drawer]');
        if (fresh && current) {
          var wasOpen = !current.hidden;
          current.innerHTML = fresh.innerHTML;
          var shouldBeOpen = wasOpen || open;
          current.hidden = !shouldBeOpen;
          setScrollLock(current, shouldBeOpen);
        }
        return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
          n.hidden = cart.item_count === 0;
        });
      })
      .catch(function (err) {
        // Never swallow this silently again — a failure here is why the
        // drawer would stay shut while the item sat in the cart.
        console.error('[solvona] cart refresh failed:', err);
      });
  }

  function initCartActions() {
    // Shipping protection toggle. Adds or removes a single unit of the add-on
    // variant, then re-renders the drawer so the subtotal reflects it.
    document.addEventListener('change', function (e) {
      var toggle = e.target.closest('[data-shipping-protection]');
      if (!toggle) return;

      var variantId = toggle.dataset.variantId;
      if (!variantId) return;

      toggle.disabled = true;
      var request;

      if (toggle.checked) {
        request = fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
      } else {
        request = fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 0 })
        });
      }

      request
        .then(function () { return refreshCart(false); })
        .catch(function () { toggle.checked = !toggle.checked; })
        .finally(function () { toggle.disabled = false; });
    });

    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (!qtyBtn) return;
      e.preventDefault();
      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: parseInt(qtyBtn.dataset.cartQty, 10),
          quantity: parseInt(qtyBtn.dataset.qty, 10)
        })
      }).then(function () { refreshCart(false); });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form.js-product-form');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) button.classList.add('loading');

      // Accept: application/json is required — without it Shopify answers
      // /cart/add with HTML, r.json() throws, and the drawer never opens.
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return r
            .json()
            .catch(function () { return {}; })
            .then(function (err) {
              throw new Error(err.description || err.message || 'Add to cart failed (' + r.status + ')');
            });
        })
        .then(function () { return refreshCart(true); })
        .catch(function (err) {
          console.error('[solvona] add to cart failed:', err);
        })
        .finally(function () { if (button) button.classList.remove('loading'); });
    });
  }

  /* --- Accordions ------------------------------------------------------- */

  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var row = trigger.closest('[data-accordion-row]');
      if (!row) return;

      var open = row.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      var panel = row.querySelector('[data-accordion-panel]');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
    });
  }

  /* --- Carousels -------------------------------------------------------- */

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;

      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var dotsWrap = root.querySelector('[data-carousel-dots]');

      var step = function () {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      };

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      if (dotsWrap) {
        var count = track.children.length;
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.dataset.index = i;
          dot.addEventListener('click', function (ev) {
            track.scrollTo({ left: step() * parseInt(ev.currentTarget.dataset.index, 10), behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        }

        var sync = function () {
          var idx = Math.round(track.scrollLeft / step());
          dotsWrap.querySelectorAll('.carousel__dot').forEach(function (d, di) {
            d.classList.toggle('is-active', di === idx);
          });
        };
        track.addEventListener('scroll', sync, { passive: true });
        sync();
      }
    });
  }

  /* --- Marquee ---------------------------------------------------------- */

  // data-speed is a reading speed in pixels/second, not a duration. Duration is
  // derived from track width so the text crosses the screen at the same pace
  // regardless of how many items there are or how wide the viewport is.
  function paceMarquee(root) {
    var track = root.querySelector('[data-marquee-track]');
    if (!track) return;
    var pps = parseFloat(root.dataset.speed);
    if (!pps || pps <= 0) pps = 8;
    // The track is duplicated, so one cycle travels half its width.
    var travel = track.getBoundingClientRect().width / 2;
    if (!travel) return;
    track.style.animationDuration = (travel / pps).toFixed(2) + 's';
  }

  function initMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function (root) {
      var track = root.querySelector('[data-marquee-track]');
      if (!track) return;
      if (track.dataset.cloned !== 'true') {
        // Duplicate the content so the CSS translate loop is seamless.
        track.innerHTML += track.innerHTML;
        track.dataset.cloned = 'true';
      }
      paceMarquee(root);
    });
  }

  var marqueeResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeResizeTimer);
    marqueeResizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-marquee]').forEach(paceMarquee);
    }, 200);
  });

  /* --- Product media gallery -------------------------------------------- */

  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var stage = root.querySelector('[data-gallery-stage]');
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      if (!stage) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.dataset.galleryThumb;
          stage.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.dataset.gallerySlide === index);
          });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  }

  /* --- Variant / bundle selection --------------------------------------- */

  // Push one offer's variant, quantity and price into the form and the button.
  function applyVariantOption(root, form, option) {
    root.querySelectorAll('[data-variant-option]').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    option.classList.add('is-selected');

    var id = option.dataset.variantId;
    var plan = option.dataset.sellingPlan || '';
    var qty = option.dataset.quantity || '1';

    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && id) idInput.value = id;

      var planInput = form.querySelector('[name="selling_plan"]');
      if (planInput) planInput.value = plan;

      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) qtyInput.value = qty;
    }

    var price = option.dataset.price;
    var compare = option.dataset.compareAt;

    document.querySelectorAll('[data-submit-price]').forEach(function (n) {
      if (price) n.textContent = money(parseInt(price, 10));
    });
    document.querySelectorAll('[data-submit-compare]').forEach(function (n) {
      if (compare && parseInt(compare, 10) > parseInt(price, 10)) {
        n.textContent = money(parseInt(compare, 10));
        n.hidden = false;
      } else {
        n.hidden = true;
      }
    });

    // The per-night line is derived from the same variant as the price above,
    // so the two can never advertise different maths.
    var nights = parseInt(option.dataset.nights, 10);
    var gummies = parseInt(option.dataset.gummies, 10);

    if (nights > 0) {
      document.querySelectorAll('[data-value-nights]').forEach(function (n) {
        n.textContent = nights;
      });
      if (gummies > 0) {
        document.querySelectorAll('[data-value-gummies]').forEach(function (n) {
          n.textContent = gummies;
        });
      }
      if (price) {
        document.querySelectorAll('[data-value-per-night]').forEach(function (n) {
          n.textContent = money(Math.round(parseInt(price, 10) / nights));
        });
      }
    }
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var form = root.closest('form.js-product-form') || document.querySelector('form.js-product-form');
      var options = root.querySelectorAll('[data-variant-option]');

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          applyVariantOption(root, form, option);
        });
      });

      // Apply the default-selected offer on load. Without this the form keeps
      // quantity 1 while the UI shows a multi-pack selected, so a customer who
      // buys without clicking gets the wrong quantity at the wrong price.
      var preselected = root.querySelector('[data-variant-option].is-selected') || options[0];
      if (preselected) applyVariantOption(root, form, preselected);
    });
  }

  /* --- Boot ------------------------------------------------------------- */

  function init() {
    initCountdowns();
    initDrawers();
    initCartActions();
    initAccordions();
    initCarousels();
    initMarquees();
    initGalleries();
    initVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialise when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
